export const SIGN_DOCUMENT_TYPES_LIST_PATH = "/sign-document-types-list";
